/* Otterfinds behaviours on top of Dawn's plumbing.
   Reveal on scroll, favorites (localStorage), colorway dots on tiles, product gallery thumbs,
   personal-note reveal, gift box (product page and bag), cart gift note, collection show-more and sort,
   newsletter dialog, help nav, mobile menu. */
(function () {
  'use strict';

  var cfg = window.otter || {};
  var FAV_KEY = 'otter:favorites';
  var POPUP_KEY = 'otter:popup-dismissed';

  function storage(get, key, value) {
    try {
      if (get) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json();
    });
  }

  /* ---------------- Reveal on scroll ---------------- */

  function initReveal() {
    var els = document.querySelectorAll('[data-of-reveal]:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (e) {
      if (e.dataset.ofObserved) return;
      e.dataset.ofObserved = '1';
      io.observe(e);
    });
  }

  /* ---------------- Favorites ---------------- */

  function readFavs() {
    try {
      var list = JSON.parse(storage(true, FAV_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function paintFav(btn, saved) {
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = saved ? (cfg.strings && cfg.strings.saved) || 'Saved' : (cfg.strings && cfg.strings.save) || 'Save';
    btn.setAttribute('aria-label', label);
    var text = btn.querySelector('[data-otter-fav-text]');
    if (text) text.textContent = label;
  }

  function initFavorites(root) {
    if (cfg.favorites === false) return;
    var favs = readFavs();
    root.querySelectorAll('[data-otter-fav]').forEach(function (btn) {
      if (btn.dataset.otterReady) return;
      btn.dataset.otterReady = '1';
      var id = btn.getAttribute('data-otter-fav');
      paintFav(btn, favs.indexOf(id) !== -1);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var list = readFavs();
        var i = list.indexOf(id);
        var saved = i === -1;
        if (saved) list.push(id); else list.splice(i, 1);
        storage(false, FAV_KEY, JSON.stringify(list));
        document.querySelectorAll('[data-otter-fav="' + id + '"]').forEach(function (b) { paintFav(b, saved); });
      });
    });
  }

  /* ---------------- Colorway dots on tiles ---------------- */

  function initDots(root) {
    root.querySelectorAll('[data-otter-dots]').forEach(function (group) {
      if (group.dataset.otterReady) return;
      group.dataset.otterReady = '1';
      var tile = group.closest('[data-otter-tile]');
      if (!tile) return;
      var img = tile.querySelector('[data-otter-tile-img]');
      var alt = tile.querySelector('[data-otter-tile-alt]');
      var link = tile.querySelector('[data-otter-tile-link]');
      group.querySelectorAll('.of-dot').forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          group.querySelectorAll('.of-dot').forEach(function (d) { d.setAttribute('aria-pressed', 'false'); });
          dot.setAttribute('aria-pressed', 'true');
          var src = dot.getAttribute('data-image');
          if (img && src) {
            img.src = src;
            img.srcset = dot.getAttribute('data-srcset') || '';
            if (alt) alt.style.display = 'none';
          }
          var url = dot.getAttribute('data-url');
          if (link && url) link.href = url;
        });
      });
    });
  }

  /* ---------------- Product gallery ---------------- */

  function initGallery(root) {
    root.querySelectorAll('[data-of-gallery]').forEach(function (g) {
      if (g.dataset.otterReady) return;
      g.dataset.otterReady = '1';
      var main = g.querySelector('[data-of-gallery-main]');
      var thumbs = g.querySelectorAll('[data-of-thumb]');
      if (!main || !thumbs.length) return;
      function select(btn) {
        thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
        btn.setAttribute('aria-current', 'true');
        main.src = btn.getAttribute('data-src');
        main.removeAttribute('srcset');
      }
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () { select(btn); });
      });
      /* follow variant changes (Dawn's variant-selects fires on the form) */
      var info = g.closest('product-info');
      if (info) {
        info.addEventListener('change', function () {
          var idInput = info.querySelector('input.product-variant-id');
          if (!idInput) return;
          var vid = idInput.value;
          var match = Array.prototype.find.call(thumbs, function (t) {
            return (t.getAttribute('data-variant-ids') || '').split(',').indexOf(vid) !== -1;
          });
          if (match) select(match);
        });
      }
    });
  }

  /* ---------------- Personal note (product page) ---------------- */

  function initNote(root) {
    root.querySelectorAll('[data-of-note-toggle]').forEach(function (box) {
      if (box.dataset.otterReady) return;
      box.dataset.otterReady = '1';
      var fields = document.getElementById(box.getAttribute('aria-controls'));
      if (!fields) return;
      var inputs = fields.querySelectorAll('input, textarea');
      var counter = fields.querySelector('[data-otter-count]');
      var area = fields.querySelector('textarea');
      function set(on) {
        fields.hidden = !on;
        inputs.forEach(function (i) { i.disabled = !on; });
        if (on) {
          var first = fields.querySelector('input');
          if (first) first.focus();
        }
      }
      if (counter && area) {
        var max = parseInt(area.getAttribute('maxlength') || '200', 10);
        var update = function () { counter.textContent = area.value.length + ' / ' + max; };
        area.addEventListener('input', update);
        update();
      }
      set(box.checked);
      box.addEventListener('change', function () { set(box.checked); });
    });
  }

  /* ---------------- Gift box on the product page ----------------
     When the switch is on and a gift box product is configured, the gift box is added
     to the bag right after the product itself. */

  function initPdpGiftBox(root) {
    root.querySelectorAll('[data-of-giftbox-variant]').forEach(function (sw) {
      if (sw.dataset.otterReady) return;
      sw.dataset.otterReady = '1';
      var variantId = parseInt(sw.getAttribute('data-of-giftbox-variant'), 10);
      if (!variantId) return;
      var form = sw.closest('form');
      if (!form) return;
      form.addEventListener('submit', function () {
        if (!sw.checked) return;
        setTimeout(function () {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var has = cart.items.some(function (i) { return i.variant_id === variantId; });
            if (has) return;
            return postJson(window.routes.cart_add_url, { items: [{ id: variantId, quantity: 1 }] }).then(function () {
              var bubble = document.getElementById('cart-icon-bubble');
              if (!bubble) return;
              return fetch(window.location.pathname + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
                if (s && s['cart-icon-bubble']) {
                  var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
                  var src = doc.querySelector('.shopify-section');
                  if (src) bubble.innerHTML = src.innerHTML;
                }
              });
            });
          }).catch(function () {});
        }, 1200);
      });
    });
  }

  /* ---------------- Gift box switch in the bag ---------------- */

  function initBagGiftBox(root) {
    root.querySelectorAll('[data-otter-giftbox]').forEach(function (box) {
      if (box.dataset.otterReady) return;
      box.dataset.otterReady = '1';
      var input = box.querySelector('[data-otter-giftbox-input]');
      if (!input) return;
      var variantId = parseInt(box.getAttribute('data-variant-id'), 10);
      var lineKey = box.getAttribute('data-line-key');
      var sectionIds = (box.getAttribute('data-sections') || '').split(',').filter(Boolean);
      var label = box.querySelector('.of-switch');

      function swap(sections) {
        Object.keys(sections || {}).forEach(function (id) {
          var html = sections[id];
          if (!html) return;
          var incoming = new DOMParser().parseFromString(html, 'text/html');
          var target = document.getElementById('shopify-section-' + id);
          var source = incoming.getElementById('shopify-section-' + id);
          if (target && source) target.innerHTML = source.innerHTML;
        });
        initAll(document);
      }

      input.addEventListener('change', function () {
        if (label) label.classList.add('is-busy');
        input.disabled = true;
        var req = input.checked
          ? postJson(window.routes.cart_add_url, { items: [{ id: variantId, quantity: 1 }], sections: sectionIds.join(',') })
          : postJson(window.routes.cart_change_url, { id: lineKey, quantity: 0, sections: sectionIds });
        req.then(function (data) {
          if (data && data.sections) swap(data.sections); else window.location.reload();
        }).catch(function () { window.location.reload(); });
      });
    });
  }

  /* ---------------- Gift note in the cart (drawer and page) ----------------
     "This is a gift" reveals the cart note. Unticking hides it and clears the note. */

  function initGift(root) {
    root.querySelectorAll('[data-of-gift-toggle]').forEach(function (box) {
      if (box.dataset.otterReady) return;
      box.dataset.otterReady = '1';
      var wrap = document.getElementById(box.getAttribute('aria-controls'));
      if (!wrap) return;
      var area = wrap.querySelector('textarea');
      box.addEventListener('change', function () {
        wrap.hidden = !box.checked;
        if (box.checked) {
          if (area) area.focus();
          return;
        }
        if (area && area.value) {
          area.value = '';
          postJson(window.routes.cart_update_url, { note: '' }).catch(function () {});
        }
      });
    });
  }

  /* ---------------- Collection: Show more, sort ---------------- */

  function initMore(root) {
    root.querySelectorAll('[data-of-more]').forEach(function (btn) {
      if (btn.dataset.otterReady) return;
      btn.dataset.otterReady = '1';
      btn.addEventListener('click', function (e) {
        var grid = document.querySelector('[data-of-grid]');
        if (!grid || !window.fetch) return;
        e.preventDefault();
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        fetch(btn.href).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('[data-of-grid]');
          if (incoming) {
            Array.prototype.slice.call(incoming.children).forEach(function (card) { grid.appendChild(card); });
          }
          var next = doc.querySelector('[data-of-more]');
          if (next) {
            btn.href = next.href;
            btn.removeAttribute('aria-busy');
          } else {
            var row = btn.closest('.of-more');
            if (row) row.remove(); else btn.remove();
          }
        }).catch(function () { window.location.href = btn.href; });
      });
    });
  }

  function initSort(root) {
    root.querySelectorAll('[data-of-sort] select').forEach(function (select) {
      if (select.dataset.otterReady) return;
      select.dataset.otterReady = '1';
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------------- Product page: delivery estimate ----------------
     Adds business days (Mon-Fri) for handling + transit and prints "arrives Oct 2 - 5". */

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function initEta(root) {
    root.querySelectorAll('[data-ot-eta]').forEach(function (el) {
      if (el.dataset.otterReady) return;
      el.dataset.otterReady = '1';
      var handling = parseInt(el.getAttribute('data-handling') || '2', 10);
      var min = parseInt(el.getAttribute('data-min') || '3', 10);
      var max = parseInt(el.getAttribute('data-max') || '4', 10);
      var shipped = addBusinessDays(new Date(), handling);
      var a = addBusinessDays(shipped, min);
      var b = addBusinessDays(shipped, Math.max(min, max));
      var mon = function (d) { return d.toLocaleDateString(undefined, { month: 'short' }); };
      var range = a.getMonth() === b.getMonth()
        ? mon(a) + ' ' + a.getDate() + (b.getDate() !== a.getDate() ? ' \u2013 ' + b.getDate() : '')
        : mon(a) + ' ' + a.getDate() + ' \u2013 ' + mon(b) + ' ' + b.getDate();
      var label = el.getAttribute('data-label') || '';
      el.innerHTML = '';
      el.appendChild(document.createTextNode(label + ' '));
      var strong = document.createElement('b');
      strong.textContent = range;
      el.appendChild(strong);
    });
  }

  /* ---------------- Product page: price on the button + sticky buy bar ---------------- */

  function initBuyBar(root) {
    root.querySelectorAll('product-info').forEach(function (info) {
      if (info.dataset.otterBuy) return;
      var price = info.querySelector('[id^="price-"]');
      var btnPrice = info.querySelector('[data-ot-btn-price]');
      var stickyPrice = document.querySelector('[data-ot-sticky-price]');
      function sync() {
        var src = info.querySelector('[data-ot-price]');
        if (!src) return;
        if (btnPrice) btnPrice.textContent = '\u00b7 ' + src.textContent.trim();
        if (stickyPrice) stickyPrice.textContent = src.textContent.trim();
      }
      if (price && 'MutationObserver' in window) {
        info.dataset.otterBuy = '1';
        new MutationObserver(sync).observe(price, { childList: true, subtree: true, characterData: true });
      }
    });

    var bar = document.querySelector('[data-ot-sticky]');
    var main = document.querySelector('[data-ot-main-add]');
    if (!bar || !main || bar.dataset.otterReady || !('IntersectionObserver' in window)) return;
    bar.dataset.otterReady = '1';
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
        var btn = bar.querySelector('button');
        if (btn) btn.tabIndex = past ? 0 : -1;
      });
    }).observe(main);
  }

  /* ---------------- Newsletter dialog ---------------- */

  function initPopup() {
    var dialog = document.querySelector('[data-otter-popup]');
    if (!dialog || dialog.dataset.otterReady) return;
    dialog.dataset.otterReady = '1';
    if (window.Shopify && window.Shopify.designMode) return;
    var days = (cfg.popup && cfg.popup.days) || 30;
    var delay = ((cfg.popup && cfg.popup.delay) || 8) * 1000;
    var last = parseInt(storage(true, POPUP_KEY) || '0', 10);
    if (last && Date.now() - last < days * 86400000) return;
    if (window.location.search.indexOf('customer_posted=true') !== -1) return;

    var shown = false;
    var lastFocus = null;
    function dismiss() {
      storage(false, POPUP_KEY, String(Date.now()));
      dialog.hidden = true;
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) { if (e.key === 'Escape') dismiss(); }
    function show() {
      if (shown) return;
      shown = true;
      lastFocus = document.activeElement;
      dialog.hidden = false;
      document.addEventListener('keydown', onKey);
      var input = dialog.querySelector('input[type="email"]');
      if (input) input.focus();
    }
    dialog.querySelectorAll('[data-otter-popup-dismiss]').forEach(function (el) { el.addEventListener('click', dismiss); });
    var form = dialog.querySelector('form');
    if (form) form.addEventListener('submit', function () { storage(false, POPUP_KEY, String(Date.now())); });
    var timer = setTimeout(show, delay);
    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= 0.5) {
        clearTimeout(timer);
        show();
        window.removeEventListener('scroll', onScroll);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- Help nav ---------------- */

  function initHelpNav() {
    var nav = document.querySelector('[data-otter-help-nav]');
    if (!nav || nav.dataset.otterReady || !('IntersectionObserver' in window)) return;
    nav.dataset.otterReady = '1';
    var links = nav.querySelectorAll('a[href^="#"]');
    var map = {};
    links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && map[en.target.id]) {
          links.forEach(function (a) { a.classList.remove('is-on'); });
          map[en.target.id].classList.add('is-on');
        }
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    Object.keys(map).forEach(function (id) {
      var el = document.getElementById(id);
      if (el) io.observe(el);
    });
    if (links[0]) links[0].classList.add('is-on');
  }

  /* ---------------- Mobile menu ---------------- */

  function initMenu() {
    var menu = document.querySelector('[data-of-menu]');
    if (!menu || menu.dataset.otterReady) return;
    menu.dataset.otterReady = '1';
    function close() {
      menu.hidden = true;
      document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-of-menu-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        menu.hidden = false;
        document.body.style.overflow = 'hidden';
        var first = menu.querySelector('a');
        if (first) first.focus();
      });
    });
    menu.querySelectorAll('[data-of-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) close(); });
  }

  /* ---------------- Welcome gift ----------------
     While the welcome code is on the cart, keep exactly one gift line next to any other
     item, and none when the gift would be alone. The Buy X Get Y discount makes it free. */

  var nativeFetch = window.fetch.bind(window);
  var welcomeBusy = false;
  var welcomeAgain = false;

  function cartPost(url, body) {
    return nativeFetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function refreshCartUI() {
    if (document.querySelector('.of-cartpage')) { window.location.reload(); return; }
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    nativeFetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var parser = new DOMParser();
        var drawer = document.querySelector('cart-drawer');
        if (drawer && s['cart-drawer']) {
          var fresh = parser.parseFromString(s['cart-drawer'], 'text/html').querySelector('cart-drawer');
          if (fresh) {
            drawer.innerHTML = fresh.innerHTML;
            drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
            var overlay = drawer.querySelector('#CartDrawer-Overlay');
            if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
          }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) {
          var sec = parser.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          bubble.innerHTML = sec ? sec.innerHTML : s['cart-icon-bubble'];
        }
      });
  }

  function syncWelcomeGift() {
    var w = cfg.welcome;
    if (!w || !w.code || !w.variantId) return;
    if (welcomeBusy) { welcomeAgain = true; return; }
    welcomeBusy = true;
    var code = String(w.code).toUpperCase();
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    var changed = false;

    nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var others = 0, gifts = [];
        cart.items.forEach(function (i) {
          if (String(i.variant_id) === String(w.variantId)) gifts.push(i); else others += i.quantity;
        });
        var hasCode = (cart.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === code; });
        // A /discount/CODE link sets a cookie before the cart exists; move it onto the cart.
        var cookie = (document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/) || [])[1];
        var cookieHasCode = cookie && decodeURIComponent(cookie).toUpperCase() === code;
        var step = Promise.resolve();
        if (!hasCode && cookieHasCode && others > 0) {
          step = cartPost('cart/update.js', { discount: w.code }).then(function (c) {
            hasCode = (c.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === code; });
            changed = true;
          });
        }
        return step.then(function () {
          var want = hasCode && others > 0 ? 1 : 0;
          var have = gifts.reduce(function (n, i) { return n + i.quantity; }, 0);
          if (want === have && gifts.length <= 1) return;
          changed = true;
          if (!gifts.length) {
            return cartPost('cart/add.js', { items: [{ id: w.variantId, quantity: 1, properties: { _welcome: '1' } }] });
          }
          var updates = {};
          gifts.forEach(function (g, idx) { updates[g.key] = idx === 0 ? want : 0; });
          return cartPost('cart/update.js', { updates: updates });
        });
      })
      .catch(function () {})
      .then(function () {
        welcomeBusy = false;
        if (changed) refreshCartUI();
        if (welcomeAgain) { welcomeAgain = false; syncWelcomeGift(); }
      });
  }

  function initWelcomeGift() {
    if (!cfg.welcome || document.documentElement.dataset.otterWelcome) return;
    document.documentElement.dataset.otterWelcome = '1';
    syncWelcomeGift();
    // Re-check after any cart change from any source (product form, drawer, cart page, add-ons).
    // Dawn only publishes cartUpdate on some paths, so watch the cart endpoints instead.
    var pageFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var res = pageFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        res.then(function () { setTimeout(syncWelcomeGift, 150); }, function () {});
      }
      return res;
    };
  }

  /* ---------------- Boot ---------------- */

  function initAll(root) {
    initReveal();
    initFavorites(root);
    initDots(root);
    initGallery(root);
    initNote(root);
    initPdpGiftBox(root);
    initBagGiftBox(root);
    initGift(root);
    initMore(root);
    initSort(root);
    initEta(root);
    initBuyBar(root);
  }

  function boot() {
    initAll(document);
    initPopup();
    initHelpNav();
    initMenu();
    initWelcomeGift();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function () { boot(); });
  var mo = new MutationObserver(function () { initAll(document); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
